module.exports = __webpack_public_path__ + "img/16.4b69d4f6.webp";